"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FieldStyled", {
  enumerable: true,
  get: function () {
    return FieldStyles.Label;
  }
});
exports.StyledField = void 0;
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Field2.default;
  }
});

var FieldStyles = _interopRequireWildcard(require("./Field.styles"));

var _Field2 = _interopRequireDefault(require("./Field"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledField = FieldStyles;
exports.StyledField = StyledField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTdHlsZWRGaWVsZCIsIkZpZWxkU3R5bGVzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRm9ybS9GaWVsZC9pbmRleC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgRmllbGRTdHlsZXMgZnJvbSAnLi9GaWVsZC5zdHlsZXMnXG5cbmV4cG9ydCB7IGRlZmF1bHQgfSBmcm9tICcuL0ZpZWxkJ1xuZXhwb3J0IHsgTGFiZWwgYXMgRmllbGRTdHlsZWQgfSBmcm9tICcuL0ZpZWxkLnN0eWxlcydcbmV4cG9ydCBjb25zdCBTdHlsZWRGaWVsZCA9IEZpZWxkU3R5bGVzXG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBRUE7Ozs7OztBQUVPLE1BQU1BLFdBQVcsR0FBR0MsV0FBcEIifQ==